import { useProjectAddAndEdit } from '@/dashboard/store/projectAddEditPopupStore';
import { WorkspaceApi } from '@/dashboard/api/workspace';
import { useAlertStore } from '@/dashboard/store/alertStore';

export async function openCreateProject(workspaceId: number) {
  const alertStore = useAlertStore();
  const projectAddAndEdit = useProjectAddAndEdit();
  const workspace = (await WorkspaceApi.getById(workspaceId)).workspace;

  if (workspace) {
    const result = await WorkspaceApi.canCreateProject(workspace?.short_link);
    if (result.can_create_project) {
      projectAddAndEdit.openPopup(workspace);
    } else {
      alertStore.open({ title: 'Directory Limit Reached', subtitle: 'You can create up to 3 free directories.', okTitle: 'Ok' });
    }
  }
}
